import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import { keyEmptyCheck } from 'aurora-utils/utils';

import { ADGMImage } from 'aurora-components';

import styles from './styles';

function NoData(props) {
  const { classes, isPmcUser, isSubLease } = props;

  return (
    <div className={classNames(classes.transactionsNotification, isPmcUser ? classes.pmcClsContainer : '')}>
      {!isPmcUser ? (
        <div className={classes.infoMessageTooltip}>
          <ADGMImage name='Information.svg' alt='information' />
          {keyEmptyCheck('do_you_have_properties_not_appearing')}
          <strong>
            <a target='_blank' href='https://www.adgm.com/contact-us/make-enquiry' rel='noreferrer'>
              {keyEmptyCheck('contact_us_now')}
            </a>
          </strong>
        </div>
      ) : (
        ''
      )}

      <figure>
        <ADGMImage name='emptystate1.png' alt='empty-state' />
      </figure>
      <div className={classNames(classes.tcTextHolder, isPmcUser ? classes.pmcTxtHolder : '')}>
        <Typography variant='body1' component='h1' className={classes.title}>
          {isPmcUser ? keyEmptyCheck('search_property') : keyEmptyCheck('no_properties_yet')}
        </Typography>
        <Typography variant='body1'>
          {isPmcUser
            ? keyEmptyCheck('pmc_no_properties_desc')
            : isSubLease
            ? keyEmptyCheck('agreement_linked_to_unit_has_sub_leases')
            : keyEmptyCheck('no_properties_yet_desc')}
        </Typography>
      </div>
    </div>
  );
}

NoData.propTypes = {
  classes: PropTypes.object.isRequired,
  isPmcUser: PropTypes.bool,
  isSubLease: PropTypes.bool,
};
NoData.defaultProps = {
  isPmcUser: false,
  isSubLease: false,
};

export default withStyles(styles)(NoData);
